export default __webpack_public_path__ + "static/media/2024-GHSI Annual Stockholders Meeting Minutes.52b8459f.pdf";